{
    "ConsidermovedtounresolvedasoverflowedLabel": "Considere as chamadas movidas para dispositivos não resolvidos como transbordadas:",
    "StatisticCalculations_SectionHeader": "Cálculos estatísticos",
    "StatisticCalculations_SectionPara": "Você pode escolher se as chamadas são consideradas como estouradas ou abandonadas quando o aplicativo deliberadamente",
    "NAME": "StatisticCalculations"
}